import Cookies from "js-cookie";

const TokenKey = "TOEKN";
const UsernameKey = "USERNAME";
export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 1 });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function setUsername(username) {
  return Cookies.set(UsernameKey, username, { expires: 1 });
}

export function getUsername() {
  return Cookies.get(UsernameKey);
}
